"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LegendItemBoxColor = _interopRequireDefault(require("./LegendItemBoxColor.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LegendItemBoxColor = function LegendItemBoxColor(_ref) {
  var isNegative = _ref.isNegative,
    boxColor = _ref.boxColor,
    active = _ref.active;
  return /*#__PURE__*/_react["default"].createElement(_LegendItemBoxColor["default"], {
    isNegative: isNegative,
    boxColor: boxColor,
    style: {
      backgroundColor: isNegative ? '' : boxColor
    } // this is needed for the pdf export
    ,
    active: active,
    "data-testid": "legend-item-box-color"
  });
};
LegendItemBoxColor.defaultProps = {
  isNegative: false,
  active: false
};
LegendItemBoxColor.propTypes = {
  isNegative: _propTypes["default"].bool,
  boxColor: _propTypes["default"].string.isRequired,
  active: _propTypes["default"].bool
};
var _default = exports["default"] = LegendItemBoxColor;